var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useEffect, useMemo } from 'react';
import { toHexColor } from 'utils/formatting/string';
/** Represents a component that renders a tag name with an adjacent color. */
export const TagContent = (_a) => {
    var { tag, onColorChange = noop } = _a, props = __rest(_a, ["tag", "onColorChange"]);
    const color = useMemo(() => { var _a; return (_a = tag.color) !== null && _a !== void 0 ? _a : toHexColor(tag.name); }, [tag.color, tag.name]);
    useEffect(() => {
        onColorChange(color);
    }, [color, onColorChange]);
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, props, { children: [_jsx(Box, { style: {
                    flexShrink: 0,
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: color,
                } }), _jsx(Box, Object.assign({ style: { wordBreak: 'break-word' } }, { children: _jsx(Text.Paragraph, { children: tag.name }) }))] })));
};
